export default class CampaingTrackingItemDto {
    constructor(code, executed, dateValue = []) {
        this.station = code
        this.executed = executed
        dateValue.forEach((date) => {
            this[date] = ''
        })
    }
}